/* eslint-disable no-unused-vars */
/* eslint-disable react/display-name */

import React, { useState, useMemo } from 'react';
import MaterialTable from 'material-table';
import { Button, NativeSelect } from '@material-ui/core';
import { Link } from 'react-router-dom';
import Pagination from 'react-js-pagination';

import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';

import Header from '../../../layout/Header';
import Subheader from '../../../layout/Subheader';
import Loading from '../../../components/Loading';

import useStyles from './style';

function CollaboratorRender({
  users,
  loading,
  getStatus,
  setStatus,
  findPermission,
  findUserAndPermission,
  setItensPerPage,
  currentPage,
  pagination,
  itensPerPage,
  setCurrentPage,
  getUsers
}) {
  const classes = useStyles();

  const [openModalFilter, setModalFilter] = useState(false);

  const memoizedTable = useMemo(
    () => (
      <MaterialTable
        className={classes.table}
        options={{
          showTitle: false,
          search: false,
          toolbar: false,
          headerStyle: {
            backgroundColor: '#F5F5F5',
            textTransform: 'none',
            fontSize: '15px',
          },
          filtering: true,
          paging: false,
          rowStyle: rowData => ({
            backgroundColor: rowData.corFundo ? rowData.corFundo : 'auto',
            color: rowData.corFonte ? rowData.corFonte : 'auto',
          })
        }}
        onRowClick={(event, rowData) => {
          if(!!findPermission('Alterar')) {
            window.location.href = window.location.origin + `/app/editar-colaborador/${rowData.colaboradorId}`
          }
        }}
        title="Multiple Actions Preview"
        columns={[
          {
            title: 'Nome',
            field: 'nome',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'CPF',
            field: 'cpf',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Status',
            field: 'status',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
            filtering: false,
          },
          {
            title: 'Ações',
            field: 'actions',
            headerStyle: {
              textAlign: 'center',
            },
            cellStyle: {
              fontSize: '13px',
              textAlign: 'center',
              padding: '8px 16px',
            },
            filtering: false,
            sorting: false,
            disableClick: true,
            render: (rowData) =>
              !!rowData.colaboradorId && (
                <>
                  {!!findPermission('Consultar') && (
                    <Link
                      className={classes.buttonVisualize}
                      to={`/app/visualizar-colaborador/${rowData.colaboradorId}`}
                    >
                      <VisibilityIcon style={{ fontSize: 30, color: '#4AAF05' }} />
                    </Link>
                  )}
                  {!!findPermission('Alterar') && (
                    <Link
                      className={classes.buttonEdit}
                      to={`/app/editar-colaborador/${rowData.colaboradorId}`}
                    >
                      <EditIcon style={{ fontSize: 30, color: '#FB8832' }} />
                    </Link>
                  )}
                </>
              ),
          },
        ]}
        data={users}
      />
    ),
    [users],
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    getUsers(pageNumber);
  };

  return (
    <div className={classes.root}>
      <Header />
      <Subheader title="Colaboradores" back="/app/home" />
      <div className={classes.content}>
        <div className={classes.tableRoot}>
          {loading ? (
            <Loading />
          ) : (
            <>
              <div className={classes.actions}>
                <Button
                  variant="contained"
                  onClick={() => setModalFilter(!openModalFilter)}
                  className={classes.button}
                >
                  <span>Filtros</span>
                </Button>
                {!!findPermission('Cadastrar') && (
                  <Link className={classes.button} to="/app/cadastrar-colaborador">
                    Novo Item
                  </Link>
                )}
                {openModalFilter && (
                  <div className={classes.filtersBox}>
                    <div className={classes.headFilter}>
                      <span className={classes.labelFilter}>Status:</span>
                      <button
                        className={classes.buttonClose}
                        onClick={() => setModalFilter(!openModalFilter)}
                      >
                        <CloseIcon style={{ fontSize: 25, color: '#fff' }} />
                      </button>
                    </div>
                    <select
                      onChange={(event) => setStatus(event.target.value)}
                      value={getStatus}
                      className={classes.selectStatus}
                    >
                      <option value="">Todos</option>
                      <option value="Afastado">Afastado</option>
                      <option value="Contratado">Contratado</option>
                      <option value="Demitido">Demitido</option>
                      <option value="Estagiario">Estagiário</option>
                      <option value="Experiencia">Experiencia</option>
                      <option value="Pendente">Pendente</option>
                      <option value="Reprovado">Reprovado</option>
                    </select>
                    <button
                      className={classes.buttonFilter}
                      onClick={() => findUserAndPermission()}
                    >
                      Aplicar Filtro
                    </button>
                  </div>
                )}
              </div>

              {memoizedTable}
              <div className="footer-table">
                <Pagination
                  activePage={currentPage}
                  itemsCountPerPage={itensPerPage}
                  totalItemsCount={pagination.qtdTotalRegistros}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
                <div className="select-page">
                  <label>Qtd. por página</label>
                  <NativeSelect
                    onChange={(e) => setItensPerPage(Number(e.currentTarget.value))}
                    value={itensPerPage}
                  >
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                  </NativeSelect>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default CollaboratorRender;
